'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ajv = require('ajv');

var _ajv2 = _interopRequireDefault(_ajv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function errorToProperty(err) {
  var _err$params = err.params,
      params = _err$params === undefined ? {} : _err$params;


  if (params.missingProperty) {
    return params.missingProperty;
  }

  return undefined;
}

var Validator = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Validator, _Component);

  function Validator(props, context) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, Validator);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

    _this.validate = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(value) {
        var validator, valid, errors;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validator = _this.state.validator;

                if (validator) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return', []);

              case 3:
                valid = validator(value);

                if (!valid) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return', []);

              case 6:
                errors = validator.errors;
                return _context.abrupt('return', errors.map(function (err) {
                  var prop = errorToProperty(err);
                  var path = err.dataPath ? err.dataPath.substr(1) : null;

                  var fullPath = path && prop ? path + '.' + prop : path || prop;

                  return (0, _extends3.default)({}, err, {
                    path: fullPath
                  });
                }));

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = (0, _extends3.default)({}, _this.getStateFromProps(props));
    return _this;
  }

  Validator.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this.setState(this.getStateFromProps(props));
  };

  Validator.prototype.getStateFromProps = function getStateFromProps(props) {
    var schema = props.schema;

    if (!schema) {
      return {
        validator: null
      };
    }

    var currentValidator = this.state && this.state.validator;
    if (!currentValidator || currentValidator.schema !== schema) {
      var ajv = this.ajv = this.ajv || (0, _ajv2.default)({
        allErrors: true
      });

      var validator = ajv.compile(schema);

      validator.schema = schema;

      return {
        validator: validator
      };
    }

    return {};
  };

  Validator.prototype.render = function render() {
    var children = this.props.children;

    if (!children) {
      return children;
    }

    return (0, _react.cloneElement)(children, {
      validate: this.validate
    });
  };

  return Validator;
}(_react.Component), _class.propTypes = {
  schema: _propTypes2.default.object,
  children: _propTypes2.default.node
}, _temp);
exports.default = Validator;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled-validate/lib/Validator.js
 ** module id = 1260
 ** module chunks = 0
 **/